import { Helpers } from '../../helpers';
import { IItem } from '../../interfaces/iitem';
import { AssetItemAdjustment } from '../asset-item-adjustment';
import { CostCodeCostType } from '../cost-code-cost-type';
import { ItemAttributesMapping } from '../item-attributes-mapping';
import { ItemCapacity } from '../item-capacity';
import { ItemCategory } from '../item-category';
import { ItemRate } from '../item-rate';
import { ItemSubCategory } from '../item-sub-category';
import { ProjectItemCapacityOverride } from '../project-item-capacity-override';
import { ProjectResourceItem } from '../project-resource-item';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { ProppantType } from '../proppant-type';
import { ResourceAssignment } from '../resource-assignment';
import { ResourceCategory } from '../resource-category';
import { ScenarioWell } from '../scenario-well';
import { UnitOfMeasure } from '../unit-of-measure';

export class ItemBase {
  ItemId: number;
  ItemNumber: number;
  OrganizationCode: string;
  RevisionCode: string | null;
  MasterOrganizationId: number | null;
  ItemCategoryId: number | null;
  RevisionLabel: string | null;
  ItemShortDescription: string | null;
  ItemLongDescription: string | null;
  RateAttributes: string | null;
  PrimaryUOM: number;
  UserItemType: string;
  InventoryItem: boolean;
  ManufacturerPartNumber: string | null;
  ManufacturerName: string | null;
  SupplierItemNumber: string | null;
  SupplierName: string | null;
  NounModifier: string | null;
  UNSPC: string | null;
  Equipment: boolean | null;
  CostCode: number;
  CostType: number;
  CostCodeDescription: string | null;
  CostTypeDescription: string | null;
  Source: string;
  ItemStatus: boolean | null;
  Processed: boolean | null;
  LastUpdatedDate: Date;
  LastUpdatedUser: string;
  InventoryCategory: string | null;
  PurchasingCategory: string | null;
  SourceSystemIdentifier: string | null;
  CostCodeCostTypeId: number | null;
  RecourceDetailId: number | null;
  Name: string | null;
  SortOrder: number | null;
  PurchasingSubCategory: string | null;
  ItemSubCategoryId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetItemAdjustments_Item?: Array<AssetItemAdjustment> | null;
  ItemAttributesMapping_Item?: Array<ItemAttributesMapping> | null;
  ItemCapacities_Item?: Array<ItemCapacity> | null;
  ItemRates_Item?: Array<ItemRate> | null;
  ProjectItemCapacityOverrides_Item?: Array<ProjectItemCapacityOverride> | null;
  ProjectResourceItems_Item?: Array<ProjectResourceItem> | null;
  ProjectResourceItemsRevisions_Item?: Array<ProjectResourceItemsRevision> | null;
  ProppantTypes_Item?: Array<ProppantType> | null;
  ResourceAssignments_Item?: Array<ResourceAssignment> | null;
  ResourceCategories_Item?: Array<ResourceCategory> | null;
  ScenarioWells_ProppantType1Item?: Array<ScenarioWell> | null;
  ScenarioWells_ProppantType2Item?: Array<ScenarioWell> | null;
  ScenarioWells_ProppantType3Item?: Array<ScenarioWell> | null;
  ScenarioWells_ProppantType4Item?: Array<ScenarioWell> | null;
  ScenarioWells_ProppantType5Item?: Array<ScenarioWell> | null;
  CostCodeCostType?: CostCodeCostType;
  ItemCategory?: ItemCategory;
  ItemSubCategory?: ItemSubCategory;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IItem) {
    if (item) {

      this.ItemId = item.ItemId;
      this.ItemNumber = item.ItemNumber;
      this.OrganizationCode = item.OrganizationCode;
      this.RevisionCode = item.RevisionCode;
      this.MasterOrganizationId = item.MasterOrganizationId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.RevisionLabel = item.RevisionLabel;
      this.ItemShortDescription = item.ItemShortDescription;
      this.ItemLongDescription = item.ItemLongDescription;
      this.RateAttributes = item.RateAttributes;
      this.PrimaryUOM = item.PrimaryUOM;
      this.UserItemType = item.UserItemType;
      this.InventoryItem = item.InventoryItem;
      this.ManufacturerPartNumber = item.ManufacturerPartNumber;
      this.ManufacturerName = item.ManufacturerName;
      this.SupplierItemNumber = item.SupplierItemNumber;
      this.SupplierName = item.SupplierName;
      this.NounModifier = item.NounModifier;
      this.UNSPC = item.UNSPC;
      this.Equipment = item.Equipment;
      this.CostCode = item.CostCode;
      this.CostType = item.CostType;
      this.CostCodeDescription = item.CostCodeDescription;
      this.CostTypeDescription = item.CostTypeDescription;
      this.Source = item.Source;
      this.ItemStatus = item.ItemStatus;
      this.Processed = item.Processed;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.InventoryCategory = item.InventoryCategory;
      this.PurchasingCategory = item.PurchasingCategory;
      this.SourceSystemIdentifier = item.SourceSystemIdentifier;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.RecourceDetailId = item.RecourceDetailId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.PurchasingSubCategory = item.PurchasingSubCategory;
      this.ItemSubCategoryId = item.ItemSubCategoryId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetItemAdjustments_Item = Helpers.createClassArray(AssetItemAdjustment, item.AssetItemAdjustments_Item);
      this.ItemAttributesMapping_Item = Helpers.createClassArray(ItemAttributesMapping, item.ItemAttributesMapping_Item);
      this.ItemCapacities_Item = Helpers.createClassArray(ItemCapacity, item.ItemCapacities_Item);
      this.ItemRates_Item = Helpers.createClassArray(ItemRate, item.ItemRates_Item);
      this.ProjectItemCapacityOverrides_Item = Helpers.createClassArray(ProjectItemCapacityOverride, item.ProjectItemCapacityOverrides_Item);
      this.ProjectResourceItems_Item = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_Item);
      this.ProjectResourceItemsRevisions_Item = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_Item);
      this.ProppantTypes_Item = Helpers.createClassArray(ProppantType, item.ProppantTypes_Item);
      this.ResourceAssignments_Item = Helpers.createClassArray(ResourceAssignment, item.ResourceAssignments_Item);
      this.ResourceCategories_Item = Helpers.createClassArray(ResourceCategory, item.ResourceCategories_Item);
      this.ScenarioWells_ProppantType1Item = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ProppantType1Item);
      this.ScenarioWells_ProppantType2Item = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ProppantType2Item);
      this.ScenarioWells_ProppantType3Item = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ProppantType3Item);
      this.ScenarioWells_ProppantType4Item = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ProppantType4Item);
      this.ScenarioWells_ProppantType5Item = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_ProppantType5Item);
      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.ItemSubCategory = new ItemSubCategory(item.ItemSubCategory);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}